var exports = {
  "h_": "xcc377c0b--78f830--description",
  "wx": "xcc377c0b--78f830--header",
  "I0": "xcc377c0b--78f830--description-htmlContent",
};

module.exports = exports;
